module.exports = __webpack_public_path__ + "img/qycw_fx.22270d29.svg";